<template>
  <div class="slider-button">
    <div class="slider-prev text-center">
      <b-button v-if="hasPrev" pill variant="primary" @click="changeStep(prevStep.id)">
        <fa icon="arrow-circle-left" /> Letzter Schritt
      </b-button>
    </div>
    <div class="slider-next text-center">
      <b-button v-if="hasNext" pill variant="primary" @click="changeStep(nextStep.id)">
        Nächster Schritt <fa icon="arrow-circle-right" />
      </b-button>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      steps: 'configurator/navigation',
      currentStep: 'configurator/currentStep'
    }),
    prevStep () {
      const i = this.steps.findIndex(step => step.id === this.currentStep.id)
      const max = this.steps.length
      let currIndex = 0
      if (i === 0) {
        currIndex = max - 1
      } else {
        currIndex = Math.max(0, i - 1)
      }
      return this.steps[currIndex]
    },
    nextStep () {
      const i = this.steps.findIndex(step => step.id === this.currentStep.id)
      const max = this.steps.length
      let currIndex = 0
      if (i === 0) {
        currIndex = 1
      } else if (i === max) {
        currIndex = 0
      } else {
        currIndex = Math.min(i + 1, max)
      }
      return this.steps[currIndex]
    },
    hasNext () {
      const i = this.steps.findIndex(step => step.id === this.currentStep.id)
      const max = this.steps.length
      if (i + 1 >= max) {
        return false
      } else {
        return true
      }
    },
    hasPrev () {
      const i = this.steps.findIndex(step => step.id === this.currentStep.id)
      // const max = this.steps.length
      if (i === 0) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    ...mapActions({
      setCurrentStep: 'configurator/setCurrentStep'
    }),
    changeStep (stepId) {
      this.$root.$refs.loading.start()
      this.setCurrentStep(stepId)
      this.$root.$refs.loading.finish()
    }
  }
}
</script>
